import "./estadisticas.scss";
import React from "react";
import TituloCard from "../../atoms/titles/Titulo";
import { Link } from "react-router-dom";
import { useState } from "react";
import ListUsuConect from "./usuariosConectados/ListUsuConect";
import AccesosWeb from "./accesosWeb/AccesosWeb";
import AccesosDiaEnCurso from "./accesosDiaEnCurso/AccesosDiaEnCurso";
import AccesosNominaDiaEnCurso from "./acesosNominaDiaEnCurso/AccesosNominaDiaEnCurso";
import HistorialUsuariosAccesos from "./historialUsuariosAccesos/HistorialUsuariosAccesos";
import HistorialUsuarioNoAccesos from "./historialUsuariosNoAccesos/HistorialUsuarioNoAccesos";
import AccesosNominas from "./accesosNomina/AccesosNomina";
import HistorialUsuariosCertificadoDigital from "./historialUsuariosCertificadoDigital/HistorialUsuarioCertificadoDigital";
import BusquedaUsuarioAcceso from "./busquedaUsuarioAcceso/BusquedaUsuarioAcceso";


const Estadisticas = () => {
  const [zona, setZona] = useState({
    links: true,
    // estadisticas: false,
    // usuWeb: false,
    // nominas: false,
    // cert: false,
    // certRet: false
    usuariosConectados:false,
    accessosWeb:false,
    accesosNomina:false,
    accesosDiaEnCurso:false,
    accesosNominaDiaEnCurso:false,
    historialUsuariosAccesos:false,
    historialUsuariosNoAccesos:false,
    historialUsuariosCertificadoDigital:false,
    busquedaUsuarioAcceso:false
  })

  const Enlaces = () => {

    return (
      <div className="">
        <div className="d-flex flex-column">
          
            <i className="fa-solid fa-caret-right my-2" onClick={() => { setZona({usuariosConectados:true }) }}>
              <Link to={""} className="fw-light">
                {" "}
                Listado de usuarios Conectados
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2">
              <Link to={""} className="fw-light" onClick={() => { setZona({accessosWeb:true }) }}>
                {" "}
                Listado de Accesos a la Web
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2" onClick={() => { setZona({accesosNomina:true }) }}>
            <Link to={""} className="fw-light">
                {" "}
                Listado de Accesos a la Nómina
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2">
              <Link to={""} className="fw-light" onClick={() => { setZona({accesosDiaEnCurso:true }) }}>
                {" "}
                Listado de Accesos del día en Curso
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2">
              <Link to={""} className="fw-light" onClick={() => { setZona({accesosNominaDiaEnCurso:true }) }}>
                {" "}
                Listado de Accesos a la Nómina del día en Curso
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2">
              <Link to={""} className="fw-light" onClick={() => { setZona({historialUsuariosAccesos:true }) }}>
                {" "}
                Listado de Usuarios que han Accedido a la Web
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2">
              <Link to={""} className="fw-light" onClick={() => { setZona({historialUsuariosNoAccesos:true }) }}>
                {" "}
                Listado de Usuarios que no han Accedido a la Web
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2" onClick={() => { setZona({historialUsuariosCertificadoDigital:true }) }}>
            <Link to={""} className="fw-light">
                {" "}
                Listado de Usuarios que han Accedido a la Web con Certificado Digital
              </Link>
            </i>
          </div>
          <div
            className=""
            onClick={() => {
              //TODO
            }}
          >
            <i className="fa-solid fa-caret-right my-2">
              <Link to={""} className="fw-light" onClick={() => { setZona({busquedaUsuarioAcceso:true }) }}>
                {" "}
                Búsqueda de un Usuario que ha accedido a la Web
              </Link>
            </i>
          </div>
        </div>


    );
  }

  return (
    <>
    <div className="container-fluid">
    <TituloCard clases={"mb-3 mt-2 d-flex justify-content-center "} tipo="tituloModal" titulo={<h2 className="tituloPagina4">Estadísticas</h2>} />
      <div className="">
        <div className="d-flex flex-column">
        {zona.links ? (<><Enlaces></Enlaces></>) : null}
        {zona.usuariosConectados ? (<><ListUsuConect setZona={setZona}/></>) : null}
        {zona.accessosWeb ? (<><AccesosWeb setZona={setZona}/></>) : null}
        {zona.accesosDiaEnCurso ? (<><AccesosDiaEnCurso setZona={setZona}/></>) : null}
        {zona.accesosNominaDiaEnCurso ? (<><AccesosNominaDiaEnCurso setZona={setZona}/></>) : null}
        {zona.historialUsuariosAccesos ? (<><HistorialUsuariosAccesos setZona={setZona}/></>) : null}
        {zona.historialUsuariosNoAccesos ? (<><HistorialUsuarioNoAccesos setZona={setZona}/></>) : null}
        {zona.accesosNomina ? (<><AccesosNominas setZona={setZona}/></>) : null}
        {zona.historialUsuariosCertificadoDigital ? (<><HistorialUsuariosCertificadoDigital setZona={setZona}/></>) : null}
        {zona.busquedaUsuarioAcceso ? (<><BusquedaUsuarioAcceso setZona={setZona}/></>) : null}





        

        </div>
      </div>
    </div>
      
    </>
  );
};
export default Estadisticas;
